var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04341 30.4124C11.1469 31.4295 13.5067 32 15.9999 32C18.4931 32 20.8529 31.4295 22.9564 30.4124L24.3477 16L22.9564 1.58763C20.8529 0.5705 18.4931 0 15.9999 0C13.5067 0 11.1469 0.5705 9.04341 1.58763L7.6521 16L9.04341 30.4124Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9562 30.4118C28.3081 27.8239 31.9996 22.3433 31.9996 16C31.9996 9.65669 28.3081 4.17607 22.9562 1.5882V30.4118Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0435 30.4118V1.5882C3.69156 4.17607 0 9.65663 0 16C0 22.3434 3.69156 27.8239 9.0435 30.4118Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5652C16 19.012 16 16 16 16H20.1739V18.0869C20.1739 18.4495 19.4783 19.778 17.7612 20.8696C17.1109 21.2831 16.4378 21.4161 16 21.5652Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8263 11.8261H16.0002V16H11.8263V11.8261Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 10.4348C18.0869 9.66639 17.464 9.04352 16.6956 9.04352C16.4419 9.04352 16.2048 9.11252 16 9.23114C15.7952 9.11252 15.5581 9.04352 15.3044 9.04352C14.536 9.04352 13.9131 9.66639 13.9131 10.4348H10.4348V17.3913C10.4348 19.981 12.4914 21.4787 14.1043 22.2551C13.9836 22.4612 13.9131 22.7004 13.9131 22.9566C13.9131 23.725 14.536 24.3479 15.3044 24.3479C15.5581 24.3479 15.7953 24.2789 16 24.1603C16.2048 24.2789 16.4419 24.3479 16.6956 24.3479C17.464 24.3479 18.0869 23.725 18.0869 22.9566C18.0869 22.7004 18.0164 22.4612 17.8957 22.2551C19.5085 21.4787 21.5652 19.9811 21.5652 17.3913V10.4348H18.0869ZM19.4783 17.3913C19.4783 17.7538 19.4783 18.857 17.7613 19.9487C17.1109 20.3622 16.4378 20.6303 16 20.7793C15.5623 20.6303 14.8891 20.3622 14.2388 19.9487C12.5218 18.857 12.5218 17.7538 12.5218 17.3913V12.5218H19.4783V17.3913Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/AD.c8fe6605.svg";
export { ForwardRef as ReactComponent };